import onlineExam from '@/utils/pageParams/onlineExam.js'
import {
  setCheckButtons,
  setTableButtons,
  setFormButtons
} from '@/utils/getbuttons.js'

const paperBase = onlineExam.paper
const questionBase = onlineExam.question

function mapOperateColumn(columns, buttons, width) {
  return (columns || []).map((col) => {
    if (col.label !== '操作') return col
    return Object.assign({}, col, {
      width: width || '100px',
      buttons: setTableButtons(buttons)
    })
  })
}

/** 试卷库内组卷：theme 用 paperLibrary，避免走 onlineExam 的企业级只读按钮过滤 */
function withPaperLibraryTheme(detailPage) {
  return (detailPage || []).map((item) => {
    if (!item || typeof item !== 'object') return item
    if (item.theme === 'onlineExam') {
      return Object.assign({}, item, { theme: 'paperLibrary' })
    }
    return item
  })
}

const paperQuestion = Object.assign({}, onlineExam.paperQuestion, {
  detailPage: withPaperLibraryTheme(onlineExam.paperQuestion.detailPage)
})

const paperLibrary = {
  ...paperBase,
  name: 'paperLibrary',
  componentTypes: [
    'navigate',
    'check',
    'tables',
    'stepForm',
    'dialogForm',
    'dialogTable',
    'drawerTable'
  ],
  detailPage: [
    {
      buttonName: '新增',
      name: 'paperLibrary',
      type: 'stepForm',
      theme: 'paperLibrary',
      step: 'paperLibraryInfo',
      label: '新增试卷库试卷'
    },
    {
      buttonNames: ['编辑', '查看'],
      name: 'paperLibrary',
      type: 'stepForm',
      theme: 'paperLibrary',
      step: 'paperLibraryInfo',
      label: '编辑试卷库试卷',
      checkType: 'checkByUid',
      checkFun: 'onlineExam/getPaperInfo'
    },
    {
      buttonName: '试题信息',
      name: 'paperQuestion',
      type: 'tables',
      theme: 'paperLibrary',
      step: 'paperQuestionList',
      label: '试卷试题列表',
      checkType: 'checkByUid',
      checkFun: 'onlineExam/getPaperInfo'
    }
  ],
  headButtons: setCheckButtons(['新增']),
  queryParams: {
    ...paperBase.queryParams,
    orgUid: () => '',
    scope: 'all'
  },
  formParams: {
    ...paperBase.formParams,
    orgUid: '',
    paperAccess: '公开'
  }
}

const questionLibrary = {
  ...questionBase,
  name: 'questionLibrary',
  componentTypes: [
    'navigate',
    'check',
    'tables',
    'stepForm',
    'dialogTable',
    'dialogForm'
  ],
  detailPage: [
    {
      buttonName: '新增',
      name: 'questionLibrary',
      type: 'stepForm',
      theme: 'questionLibrary',
      step: 'questionLibraryInfo',
      label: '新增试题库题目'
    },
    {
      buttonName: '导入题目',
      type: 'path',
      path: '/workbench/questionImport?from=questionLibrary'
    },
    {
      buttonName: '编辑',
      name: 'questionLibrary',
      type: 'stepForm',
      theme: 'questionLibrary',
      step: 'questionLibraryInfo',
      label: '编辑试题库题目',
      checkType: 'checkByUid',
      checkFun: 'onlineExam/getQuestionInfo'
    },
    {
      buttonName: '重置难度',
      name: 'resetDifficulty',
      type: 'dialogForm',
      pageStatus: 'add'
    },
    {
      buttonName: '加标签',
      name: 'batchTagLabels',
      type: 'dialogForm',
      pageStatus: 'add'
    },
    {
      buttonNames: ['设置题目选项', '设置题目答案'],
      name: 'options',
      type: 'dialogForm'
    },
    {
      buttonNames: ['编辑题干图表', '编辑解析图表'],
      name: 'imgTables',
      type: 'dialogForm'
    }
  ],
  headButtons: setCheckButtons([
    '新增',
    { name: '重置难度', icon: 'el-icon-refresh', type: '' },
    '审核通过',
    { name: '加标签', icon: 'el-icon-price-tag', type: '' },
    '批量删除',
    '导入题目',
    { name: '下载导入模板', type: '' }
  ]),
  queryParams: {
    ...questionBase.queryParams,
    orgUid: () => '',
    scope: 'all'
  },
  formParams: {
    ...questionBase.formParams,
    orgUid: '',
    questionAccess: '公开'
  },
  resetDifficulty: {
    title: '按正确率重置题目难度',
    addFun: 'onlineExam/resetQuestionDifficulty',
    getParentFun: 'onlineExam/getQuestionList',
    formParams: {
      minSubmit: 20,
      easyRate: 80,
      hardRate: 50
    },
    formRules: {
      minSubmit: [
        { required: true, message: '请输入答题次数阈值', trigger: 'blur' }
      ],
      easyRate: [
        { required: true, message: '请输入简单正确率阈值', trigger: 'blur' }
      ],
      hardRate: [
        { required: true, message: '请输入困难正确率阈值', trigger: 'blur' }
      ]
    },
    formData: [
      {
        key: 'minSubmit',
        label: '答题次数阈值',
        type: 'input',
        number: true,
        placeholder: '达到该次数才重置',
        span: 18
      },
      {
        key: 'easyRate',
        label: '简单正确率≥',
        type: 'input',
        number: true,
        inputButton: '%',
        span: 18
      },
      {
        key: 'hardRate',
        label: '困难正确率≤',
        type: 'input',
        number: true,
        inputButton: '%',
        span: 18
      },
      {
        key: 'resetTip',
        type: 'tag',
        tag: '仅处理答题次数达到阈值的题目。中间区间重置为「中等」。不改题干与试卷关联。',
        span: 18
      }
    ]
  },
  batchTagLabels: {
    title: '批量加标签',
    addFun: 'onlineExam/batchUpdateQuestionTags',
    formParams: {
      knowledgeType: [],
      applicableUsers: []
    },
    formRules: {},
    formData: [
      {
        key: 'knowledgeType',
        label: '知识点类型',
        type: 'select',
        options: (params) => {
          return [{ label: '未分类', value: '未分类' }].concat(
            params.dictionarys.dataType || []
          )
        },
        multiple: true,
        filterable: true,
        create: true,
        placeholder: '尽量按字典选择，没有可自行输入；可选多个',
        span: 18
      },
      {
        key: 'applicableUsers',
        label: '适用对象',
        type: 'select',
        options: (params) => {
          return [{ label: '未分类', value: '未分类' }].concat(
            params.dictionarys.applicableUsers || []
          )
        },
        multiple: true,
        filterable: true,
        create: true,
        placeholder: '尽量按字典选择，没有可自行输入；可选多个',
        span: 18
      },
      {
        key: 'tagTip',
        type: 'tag',
        tag: '请先勾选题目再打开本弹窗。未选择的一类不改动；选择后将覆盖已勾选题目的对应标签。',
        span: 18
      }
    ]
  }
}

const publicPapers = {
  ...paperBase,
  name: 'publicPapers',
  componentTypes: ['navigate', 'check', 'tables', 'stepForm'],
  addFun: null,
  editFun: null,
  deleteFun: null,
  confirmFun: null,
  headButtons: [],
  detailPage: [
    {
      buttonName: '查看',
      name: 'publicPapers',
      type: 'stepForm',
      theme: 'publicPapers',
      step: 'publicPapersInfo',
      label: '查看公共试卷',
      checkType: 'checkByUid',
      checkFun: 'onlineExam/getPaperInfo',
      pageStatus: 'check'
    },
    {
      buttonName: '试题信息',
      name: 'paperQuestion',
      type: 'tables',
      theme: 'onlineExam',
      step: 'paperQuestionList',
      label: '查看试题信息',
      checkType: 'checkByUid',
      checkFun: 'onlineExam/getPaperInfo',
      pageStatus: 'check'
    }
  ],
  queryParams: {
    ...paperBase.queryParams,
    // 仍带当前机构，供后端校验「公共试卷库」页签；列表范围由 scope=public 决定
    orgUid: (params) => params.orgValue,
    scope: 'public'
  },
  columns: mapOperateColumn(paperBase.columns, ['查看'], '100px'),
  formData: Object.assign({}, paperBase.formData, {
    card: '公共试卷信息',
    bottomButtons: setFormButtons(['取消'])
  })
}

const publicQuestions = {
  ...questionBase,
  name: 'publicQuestions',
  componentTypes: ['navigate', 'check', 'tables'],
  addFun: null,
  editFun: null,
  deleteFun: null,
  addArray: false,
  headButtons: [],
  selectColumn: false,
  detailPage: [],
  queryParams: {
    ...questionBase.queryParams,
    orgUid: (params) => params.orgValue,
    scope: 'public'
  },
  // 可展开行查看全部内容，不再需要操作列「查看」
  columns: (questionBase.columns || []).filter((col) => col.label !== '操作'),
  formData: Object.assign({}, questionBase.formData, {
    card: '公共试题信息',
    bottomButtons: setFormButtons(['取消'])
  })
}

export default {
  paperLibrary,
  paperQuestion,
  questionLibrary,
  publicPapers,
  publicQuestions
}
